/* ============================================================
   Olivia Blaire — theme.js
   Vanilla JS. No framework. Handles:
   - Mobile menu + cart drawer open/close
   - Cart: add / change qty / remove via Shopify AJAX API (/cart/*.js)
   - Product: variant selection -> price + variant id, quantity stepper,
     bundle selector (sets quantity), gallery slider/thumbnails
   - FAQ + info accordions
   - "See the difference" auto-advancing photo strip
   - "You'll love" + review-highlight mobile swipers
   - Instagram story viewer
   Money is formatted with Shopify's shop money format (set on window.OB).
   ============================================================ */
(function () {
  'use strict';

  var OB = window.OB || {};
  var moneyFormat = OB.moneyFormat || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, dollars + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, dollars)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dollars + ',' + parts[1]);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Drawers (menu + cart) ---------------- */
  function openDrawer(name) {
    var drawer = $('[data-drawer="' + name + '"]');
    var overlay = $('[data-overlay="' + name + '"]');
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(name) {
    var drawer = $('[data-drawer="' + name + '"]');
    var overlay = $('[data-overlay="' + name + '"]');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  window.OBDrawer = { open: openDrawer, close: closeDrawer };

  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-drawer-open]');
    if (openEl) { e.preventDefault(); openDrawer(openEl.getAttribute('data-drawer-open')); return; }
    var closeEl = e.target.closest('[data-drawer-close]');
    if (closeEl) { e.preventDefault(); closeDrawer(closeEl.getAttribute('data-drawer-close')); return; }
  });

  /* ---------------- Cart AJAX ---------------- */
  function renderCart(cart) {
    // count badges
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    var body = $('[data-cart-body]');
    if (!body) return;
    var empty = $('[data-cart-empty]');
    var filled = $('[data-cart-filled]');

    if (cart.item_count === 0) {
      if (empty) empty.hidden = false;
      if (filled) filled.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (filled) filled.hidden = false;

    var countLabel = $('[data-cart-count-label]');
    if (countLabel) countLabel.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    var itemsWrap = $('[data-cart-items]');
    itemsWrap.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="' + item.product_title + '">'
        : '<div class="ob-ph" style="width:100%;height:100%"></div>';
      var compare = '';
      if (item.original_line_price > item.final_line_price) {
        compare = '<s>' + formatMoney(item.original_line_price) + '</s>';
      }
      var variant = (item.options_with_values || []).map(function (o) {
        return o.name + ': ' + o.value;
      }).join(' &middot; ');
      return '' +
        '<div class="ob-cart__item" data-line-key="' + item.key + '">' +
          '<div class="ob-cart__thumb">' + img + '</div>' +
          '<div style="flex:1;min-width:0">' +
            '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:10px">' +
              '<span class="ob-cart__title">' + item.product_title + '</span>' +
              '<button class="ob-cart__remove" aria-label="Remove item" data-cart-remove="' + item.key + '">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7 H20"/><path d="M9 7 V5 H15 V7"/><path d="M6.5 7 L7.5 20 H16.5 L17.5 7"/></svg>' +
              '</button>' +
            '</div>' +
            (variant ? '<div class="ob-cart__variant">' + variant + '</div>' : '') +
            '<div class="ob-cart__line">' +
              '<div class="ob-cart__qty">' +
                '<button aria-label="Decrease" data-cart-minus="' + item.key + '">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button aria-label="Increase" data-cart-plus="' + item.key + '">+</button>' +
              '</div>' +
              '<div class="ob-cart__price">' + compare + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    // Crossed-out "before" price on the Total row: sum of original line prices.
    var compareTotal = cart.items.reduce(function (sum, item) {
      return sum + item.original_line_price;
    }, 0);
    var compareEl = $('[data-cart-compare]');
    if (compareEl) {
      if (compareTotal > cart.total_price) {
        compareEl.textContent = formatMoney(compareTotal);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(id, quantity, properties) {
    var payload = { id: id, quantity: quantity || 1 };
    if (properties) payload.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { openDrawer('cart'); return cart; });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { openDrawer('cart'); return cart; });
  }

  function setCartLoading(on) {
    var el = $('[data-drawer="cart"]');
    if (el) el.classList.toggle('ob-cart--loading', !!on);
  }

  function changeLine(key, quantity) {
    setCartLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); setCartLoading(false); return cart; })
      .catch(function (e) { setCartLoading(false); throw e; });
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-cart-plus]');
    var minus = e.target.closest('[data-cart-minus]');
    var remove = e.target.closest('[data-cart-remove]');
    if (plus || minus || remove) {
      var row = e.target.closest('[data-line-key]');
      var qtyEl = row ? $('.ob-cart__qty span', row) : null;
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (plus) changeLine(plus.getAttribute('data-cart-plus'), current + 1);
      else if (minus) changeLine(minus.getAttribute('data-cart-minus'), Math.max(0, current - 1));
      else if (remove) changeLine(remove.getAttribute('data-cart-remove'), 0);
    }
  });

  /* ---------------- Product form ---------------- */
  function initProduct(root) {
    var data = root.getAttribute('data-product-json');
    var product = data ? JSON.parse(data) : null;
    var selected = {};
    var variantIdInput = $('[data-variant-id]', root);
    var qtyInput = $('[data-qty-input]', root);
    var priceNow = $('[data-price-now]', root);
    var priceWas = $('[data-price-was]', root);
    var addBtn = $('[data-add-to-cart]', root);

    // variant option buttons
    $all('[data-option-value]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        selected[pos] = btn.getAttribute('data-option-value');
        $all('[data-option-position="' + pos + '"]', root).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateVariant();
      });
    });
    // seed selection from .is-active
    $all('[data-option-value].is-active', root).forEach(function (b) {
      selected[b.getAttribute('data-option-position')] = b.getAttribute('data-option-value');
    });

    function updateVariant() {
      if (!product) return;
      var match = product.variants.find(function (v) {
        return (v.options || []).every(function (val, i) {
          var pos = (i + 1).toString();
          return selected[pos] == null || selected[pos] === val;
        });
      });
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceNow) priceNow.textContent = formatMoney(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = formatMoney(match.compare_at_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.getAttribute('data-label') || 'ADD TO CART') : 'SOLD OUT';
      }
    }

    // bundle selector -> sets quantity (extend with Shopify discounts as needed)
    $all('[data-bundle]', root).forEach(function (bundle) {
      bundle.addEventListener('click', function () {
        $all('[data-bundle]', root).forEach(function (b) { b.classList.remove('is-active'); });
        bundle.classList.add('is-active');
        var q = parseInt(bundle.getAttribute('data-bundle-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = q;
      });
    });
    // apply the default-selected bundle's quantity on load
    var activeBundle = $('[data-bundle].is-active', root);
    if (activeBundle && qtyInput) qtyInput.value = parseInt(activeBundle.getAttribute('data-bundle-qty'), 10) || 1;

    // quantity stepper
    var dec = $('[data-qty-dec]', root);
    var inc = $('[data-qty-inc]', root);
    if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    // add to cart
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.classList.contains('is-loading')) return; // ignore clicks while pending
        var orig = addBtn.getAttribute('data-label') || addBtn.textContent;

        // If the active bundle has per-unit variant selects, add each chosen variant.
        var items = null;
        var activeBundle = $('[data-bundle].is-active', root);
        if (activeBundle) {
          var selects = $all('[data-bundle-variant]', activeBundle);
          if (selects.length) {
            var counts = {};
            selects.forEach(function (s) { if (s.value) counts[s.value] = (counts[s.value] || 0) + 1; });
            items = Object.keys(counts).map(function (vid) { return { id: vid, quantity: counts[vid] }; });
          }
        }

        // pending state: spinner + disabled
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        addBtn.innerHTML = '<span class="ob-spinner" aria-hidden="true"></span><span class="ob-btn__sr">Adding\u2026</span>';

        function reset(label, delay) {
          addBtn.classList.remove('is-loading');
          addBtn.textContent = label;
          setTimeout(function () {
            addBtn.textContent = orig;
            addBtn.disabled = false;
          }, delay);
        }

        var request;
        if (items && items.length) {
          request = addItems(items);
        } else {
          var id = variantIdInput ? variantIdInput.value : (product && product.variants[0].id);
          var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          request = addToCart(id, qty);
        }

        request
          .then(function () {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = orig;
            addBtn.disabled = false;
          })
          .catch(function () { reset('TRY AGAIN', 1600); });
      });
    }

    updateVariant();
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery(root) {
    var slides = $all('[data-gallery-slide]', root);
    var dots = $all('[data-gallery-dot]', root);
    var thumbs = $all('[data-gallery-thumb]', root);
    var idx = 0;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    go(0);
  }

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-toggle]');
    if (!btn) return;
    var item = btn.closest('[data-accordion-item]');
    if (item) item.classList.toggle('is-open');
  });

  /* ---------------- Auto photo strip ---------------- */
  function initStrip(root) {
    var track = $('[data-strip-track]', root);
    if (!track) return;
    var perView = 3;
    var step = 100 / (perView * 2); // % of the 200%-wide track = one card
    var slide = 0;
    setInterval(function () {
      slide += 1;
      track.classList.remove('no-anim');
      track.style.transform = 'translateX(-' + (slide * step) + '%)';
      if (slide >= perView) {
        setTimeout(function () {
          track.classList.add('no-anim');
          slide = 0;
          track.style.transform = 'translateX(0)';
          requestAnimationFrame(function () { requestAnimationFrame(function () { track.classList.remove('no-anim'); }); });
        }, 640);
      }
    }, 2000);
  }

  /* ---------------- Mobile swipers (love / highlights) ---------------- */
  /* Pre-rendered slides; show one at a time, toggle dots + arrows. */
  function initSwiper(root) {
    var slides = $all('[data-swiper-slide]', root);
    var dots = $all('[data-swiper-dot]', root);
    if (!slides.length) return;
    var idx = parseInt(root.getAttribute('data-swiper-start') || '0', 10);
    if (idx >= slides.length) idx = 0;
    function show() {
      slides.forEach(function (s, k) { s.hidden = k !== idx; });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    $all('[data-swiper-prev]', root).forEach(function (b) { b.addEventListener('click', function () { idx = (idx - 1 + slides.length) % slides.length; show(); }); });
    $all('[data-swiper-next]', root).forEach(function (b) { b.addEventListener('click', function () { idx = (idx + 1) % slides.length; show(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { idx = k; show(); }); });
    show();
  }

  /* ---------------- Instagram story viewer ---------------- */
  function initStories() {
    var viewer = $('[data-story-viewer]');
    if (!viewer) return;
    var stories = $all('[data-story-open]');
    var bar = $('[data-story-bar]', viewer);
    var nameEl = $('[data-story-name]', viewer);
    var timeEl = $('[data-story-time]', viewer);
    var labelEl = $('[data-story-label]', viewer);
    var mediaEl = $('[data-story-media]', viewer);
    var current = 0, progress = 0, paused = false, timer = null;
    var data = stories.map(function (el) {
      return { name: el.getAttribute('data-story-name'), time: el.getAttribute('data-story-time') || '10m', video: el.getAttribute('data-story-video') || '' };
    });

    function paint() {
      var s = data[current];
      if (nameEl) nameEl.textContent = s.name;
      if (timeEl) timeEl.textContent = s.time;
      if (s.video && mediaEl) {
        mediaEl.innerHTML = '<video src="' + s.video + '" autoplay muted playsinline loop></video>';
        if (labelEl) labelEl.hidden = true;
      } else {
        if (mediaEl) mediaEl.innerHTML = '';
        if (labelEl) { labelEl.hidden = false; labelEl.textContent = '[ story video \u2014 ' + s.name + ' ]'; }
      }
    }
    function tick() {
      if (paused) return;
      progress += 0.6;
      if (progress >= 100) { next(); return; }
      if (bar) bar.style.width = progress + '%';
    }
    function start() { clearInterval(timer); progress = 0; if (bar) bar.style.width = '0%'; paint(); timer = setInterval(tick, 45); }
    function open(i) { current = i; viewer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; paused = false; start(); }
    function close() { clearInterval(timer); viewer.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    function next() { current = (current + 1) % data.length; start(); }
    function prev() { current = (current - 1 + data.length) % data.length; start(); }

    stories.forEach(function (el, i) { el.addEventListener('click', function () { open(i); }); });
    var closeBtn = $('[data-story-close]', viewer); if (closeBtn) closeBtn.addEventListener('click', close);
    var nextBtn = $('[data-story-next]', viewer); if (nextBtn) nextBtn.addEventListener('click', next);
    var prevBtn = $('[data-story-prev]', viewer); if (prevBtn) prevBtn.addEventListener('click', prev);
    var pauseBtn = $('[data-story-pause]', viewer);
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.querySelectorAll('svg').forEach(function (svg) { svg.hidden = !svg.hidden; });
    });
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    $all('[data-product-root]').forEach(initProduct);
    $all('[data-gallery]').forEach(initGallery);
    $all('[data-strip]').forEach(initStrip);
    $all('[data-swiper-root]').forEach(initSwiper);
    initStories();
    fetchCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
